import { render } from "./MacLoader.vue?vue&type=template&id=f2041456"
const script = {}

import "./MacLoader.vue?vue&type=style&index=0&id=f2041456&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__